import { gql } from '../../../../types/__codegen__/sanity';

export const GET_CONSIDERATION_CONTENT = gql(`
  query getConsiderationContent($slug: String) {
    allConsiderationContent(where: { identifier: { current: { eq: $slug } } }) {
      __typename
      id: _id
      name
      title
      summary: summaryRaw
      identifier {
        ...SlugFields
      }
      insuranceType {
        identifier {
          ...SlugFields
        }
      }
      productType {
        identifier {
          ...SlugFields
        }
      }
      urlObject {
        ...UrlObjectFields
      }
      imageObject {
        ...ImageObjectFields
      }
      termsAndConditions {
        descriptionRaw
        footnotes {
          linkReferenceSymbol
          descriptionRaw
        }
        epilogueRaw
      }
      metadataObject {
        name
        descriptionRaw
      }
      refersToContent {
        ... on ProductListSection {
          defaultScale
          title
          _type
          productLists {
            __typename
            ... on ProductList {
              ...ProductListFields
            }
          }
        }
        ... on ValuePropositionsObject {
          title
          valuePropositionsReference {
            ...ValuePropositionFields
          }
          urlObject {
            ...UrlObjectFields
          }
        }
        ... on QuestionsList {
          title
          questions {
            ... on Question {
              _id
              question
              answerRaw
            }
          }
        }
        ... on SellingPointGroup {
          ...SellingPointFields
        }
        ... on TopicGroup {
          ...TopicGroupFields
        }
        ... on PromotionalCtaList {
          items {
            ... on Service {
              ...ContentTileFields
              imageObject {
                ...ImageObjectFields
              }
            }
          }
        }
        ... on ExternalContent {
          __typename
          identifier {
            current
          }
          title
        }
      }
    }
  }
`);
